/*
 * @Description:
 * @Author: pcc
 * @Date: 2023-04-27 14:57:52
 * @LastEditors: xie
 * @LastEditTime: 2025-12-10 14:24:03
 */
import request from "@/utils/request";
import reportRequest from "@/utils/reportRequest";

// 分页查询厂家择样记录
export function QuoteHistoryQueryPage(data) {
  return request({
    url: "cuss/QuoteHistory/QueryPage",
    method: "post",
    data,
  });
}

// 获取厂商信息
export function GetManufacturerInfo(data) {
  return request({
    url: "cuss/ProductBasic/GetManufacturerInfo",
    method: "post",
    data,
  });
}

/**
 * 获取不完整的信息条数（没有图片或包装规格，产品规格，毛重，净重不全）
 * @param {*} data
 * @returns
 */
export function getIncompleteProductCount(data) {
  return request({
    url: "cuss/ProductBasic/GetIncompleteProductCount",
    method: "post",
    data,
  });
}
/**
 * 获取包装列表
 */
export function getPacks(data) {
  return request({
    url: "/cuss/ProductBasic/GetPacks",
    method: "post",
    data,
  });
}
/**
 * 校验厂商
 * @param {*} data
 * @returns
 */
export function checkManufacturer(data) {
  return request({
    url: "cuss/ProductBasic/CheckManufacturer",
    method: "post",
    data,
  });
}

//分页查询打印凭条
export function ProductBasicQueryPage(data) {
  return request({
    url: "cuss/ProductBasic/QueryPage",
    method: "post",
    data,
  });
}

// 获取排号列表
export function HallWorkGetList(data) {
  return request({
    url: "cuss/HallWork/GetList",
    method: "post",
    data,
  });
}

// 获取洽谈室设置
export function HallWorkGetWorkConfig(data) {
  return request({
    url: "cuss/HallWork/GetWorkConfig",
    method: "post",
    data,
  });
}

// 打印厂商排号
export function printARowNumber(data) {
  return request({
    url: "cuss/HallWork/PrintARowNumber",
    method: "post",
    data,
  });
}

// 获取语音列表
export function HallWorkGetSpeakList(data) {
  return request({
    url: "cuss/HallWork/GetSpeakList",
    method: "post",
    data,
  });
}

// 删除语音
export function HallWorkDeleteSpeak(data) {
  return request({
    url: "cuss/HallWork/DeleteSpeak",
    method: "post",
    data,
  });
}

/**
 * 解密小竹熊二维码
 * @param {*} data
 * @returns
 */
export function decryptingQRcode(data) {
  return request({
    url: "cuss/ProductBasic/DecryptingQRcode",
    method: "post",
    data,
  });
}

/**
 * 解密宏升二维码
 * @param {*} data
 * @returns
 */
export function decryptingHSQRcode(data) {
  return request({
    url: "cuss/ProductBasic/DecryptingHSQRcode",
    method: "post",
    data,
  });
}

/**
 * 获取展厅识别码
 * @returns
 */
export function getExhibitionCode() {
  return request({
    url: "cuss/ProductBasic/GetExhibitionCode",
    method: "post",
  });
}

/**
 * 获取条码报表
 * @returns
 */
export function getBarCodeReport() {
  return request({
    url: "cuss/ProductBasic/GetBarCodeReport",
    method: "post",
  });
}
/**
 * 获取默认报表Id
 */
export function getDefaultReport(data) {
  return request({
    url: "/cuss/ProductBasic/GetDefaultReport",
    method: "post",
    data,
  });
}
/**
 * 保存报表参数
 * @param {*} data
 * @returns
 */
export function saveProductBarCodeReport(data) {
  return request({
    url: "cuss/ProductBasic/SaveProductBarCodeReport",
    method: "post",
    data,
  });
}

/**
 * 生成打印报表
 * @param {*} data
 * @returns
 */
export function reportPrintFile(data) {
  return reportRequest({
    url: "DXXRDV/Report/PrintFileCuss",
    method: "post",
    data,
  });
}

/**
 * 删除打印缓存
 * @param {*} data
 * @returns
 */
export function deletePrintCache(data) {
  return reportRequest({
    url: "DXXRDV/Report/DeletePrintCache",
    method: "post",
    data,
  });
}

/**
 * 获取排号报表
 * @returns
 */
export function getHallWorkReport() {
  return request({
    url: "cuss/HallWork/getHallWorkReport",
    method: "post",
  });
}

/**
 * 保存排号报表参数
 * @param {*} data
 * @returns
 */
export function saveHallWorkReport(data) {
  return request({
    url: "cuss/HallWork/SaveHallWorkReport",
    method: "post",
    data,
  });
}

/**
 * 获取排号错误报表
 * @returns
 */
export function getHallWorkErrorReport() {
  return request({
    url: "cuss/HallWork/GetHallWorkErrorReport",
    method: "post",
  });
}

/**
 * 保存排号错误报表
 * @param {*} data
 */
export function saveHallWorkErrorReport(data) {
  return request({
    url: "cuss/HallWork/SaveHallWorkErrorReport",
    method: "post",
    data,
  });
}

/**
 * 保存排号错误报表
 * @param {*} data
 */
export function verificationPassWord(data) {
  return request({
    url: "/cuss/QuoteHistory/VerificationPassWord",
    method: "post",
    data,
  });
}
/**
 * 样品进出登记
 * @param {*} data
 */
export function createProductOut(data) {
  return request({
    url: "cuss/ProductBasic/CreateProductOut",
    method: "post",
    data,
  });
}
